import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { NgStyle } from '@angular/common';
import { CurrencyAmountDisplay } from 'src/app/shared/utils/currency/currency-format';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { ThemePipe } from '../../../../core/pipes/theme.pipe';
import { CurrencyIconComponent } from '../../../../ui/currency/currency-icon/currency-icon.component';

// The "Entry <fee>" line under a tier card's prize: a prefix label, the primary fee with its
// currency icon, the secondary fee in parentheses on match-and-user skins, and projected
// trailing content (the free card's "Free" word). The paid and free cards both render this
// so the line cannot drift between them. `struck` strikes the whole amount group — primary
// and secondary together — for a fee that no longer applies.
@Component({
  selector: 'app-wager-entry-line',
  templateUrl: './wager-entry-line.component.html',
  styleUrls: ['./wager-entry-line.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, ThemePipe, CurrencyIconComponent],
})
export class WagerEntryLineComponent {
  readonly prefix = input.required<string>();
  readonly prefixStyles = input.required<[string, string][]>();
  readonly primary = input.required<CurrencyAmountDisplay>();
  readonly secondary = input<CurrencyAmountDisplay | null>(null);
  readonly feeStyles = input.required<[string, string][]>();
  readonly struck = input(false);

  private readonly themeService = inject(ThemeService);

  readonly shownSecondary = computed(() =>
    this.themeService.hasSecondaryCurrency ? this.secondary() : null,
  );
}
